import Header from "../../components/header/index.js";
import LeftMenu from "../../components/left-menu/index.js";
import Grid from '@mui/material/Grid';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import Post from "../../pages/ListKontrak/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import InputAdornment from '@mui/material/InputAdornment';
export default function CreatePost(){
    const [address1,setAddress1] = useState("-")
    const nowstate = useSelector(state => state);
    const [sales,setSales]= useState(nowstate.user?.sales??"-")
    const [date,setDate]= useState(new Date())
    const [dateEnd,setDateEnd]= useState(new Date())
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const [query,setQuery] = useState("")
    const [skip, setSkip] = useState(0)
    const [searchThis, setsearchThis]= useState("Phone");
    const [removedPost,setRemovedPost]=useState(0)
    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis,nowstate.user.sales);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data.data)

                    if(data.data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }


                    const yoyo = data.data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,nowstate.user.sales);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }

            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
    const previewInquiry = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setPreviewVisibility(true)
        const currid = post._id
    }
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length+removedPost);
        }
    }
    const determineCellStyle = (content) => {
        let style = {...commonStyles, borderColor: 'grey.100', cursor: 'pointer', backgroundColor: '#eeff41'};
        let textColor = 'black';
    
        if (content === '') {
            style.backgroundColor = 'white';
        } else if (content === 'stuck') {
            style.backgroundColor = 'red';
        } else if (content === 'done') {
            style.backgroundColor = 'green';
        } else if (content === 'X') {
            style.backgroundColor = 'black';
            textColor = 'white';
        }
    
        return { style, textColor };
    };

    const MyTableCell = ({ post, previewInquiry, cellType }) => {
        let textContent = 'N/A';
    
        switch (cellType) {
            case 'Nama':
                textContent = post.Nama ? post.Nama.slice(0, 7) : 'N/A';
                break;
            case 'Phone':
                textContent = post.Phone;
                break;
            case 'ProdukInterest':
            case 'LokasiInterest':
                textContent = Array.isArray(post[cellType]) 
                    ? post[cellType].join(', ').slice(0, 7)
                    : (post[cellType] ? String(post[cellType]).slice(0, 7) : 'N/A');
                break;
            default:
                break;
        }
    
        const { style, textColor } = determineCellStyle(textContent);
    
        return (
            <TableCell sx={style} onClick={() => previewInquiry(post)}>
                <span style={{ color: textColor }}>{textContent}</span>
            </TableCell>
        );
    };
    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis,nowstate.user.sales);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,nowstate.user.sales);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }  
    const donePost = (postId) => {
        setRemovedPost(removedPost+1)
        setPosts(posts.filter(post => post._id !== postId));
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateInqContacted`,{
            id: currPreview._id
        })
    };

    const spamPost = (postId) => {
        setRemovedPost(removedPost+1)
        setPosts(posts.filter(post => post._id !== postId));
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updatedInqSpam`,{
            id: currPreview._id
        })
    };

    const invalidPost = (postId) => {
        setRemovedPost(removedPost+1)
        setPosts(posts.filter(post => post._id !== postId));
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updatedInqNoneNumber`,{
            id: currPreview._id
        })
    };

    useEffect(() => {
        fetchPosts();
        console.log(posts)
        
    }, [skip,query]);
    const commonStyles = {
        border: 1,
      };
return(
    <Grid container>
        <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <Grid xs={12} sx={{mb: 5}}>
                        <b>Sudah Hubungi?</b>
                    </Grid>
                    <Grid xs={12}>
                    <Typography fontSize="20px">Nama: {currPreview.Nama?? "n/a"}</Typography>
                    </Grid>
                    <Grid xs={12} sx={{mb:5}}>
                    <Typography fontSize="20px">Nomor: {currPreview.Phone?? "n/a"}</Typography>
                    </Grid>
                    <Grid xs={12}>
                    <Typography fontSize="20px">Produk: {Array.isArray(currPreview.ProdukInterest) 
                                    ? currPreview.ProdukInterest.join(', ')
                                    : (currPreview.ProdukInterest ? String(currPreview.ProdukInterest) : 'N/A')} </Typography>
                    </Grid>
                    <Grid xs={12} sx={{mb:5}}>
                    <Typography fontSize="20px">Lokasi: {Array.isArray(currPreview.LokasiInterest) 
                                    ? currPreview.LokasiInterest.join(', ')
                                    : (currPreview.LokasiInterest ? String(currPreview.LokasiInterest) : 'N/A')}</Typography>
                    </Grid>
                        {currPreview.chatLink ? (
                            <Grid xs={12} sx={{ mb: 5, display: 'flex', justifyContent: 'center' }}>
                                <Button 
                                    variant="contained" 
                                    onClick={() => window.open(currPreview.chatLink, '_blank')}
                                    sx={{mr:5}}
                                >
                                    Cek Chat #1
                                </Button>
                                <Button 
                                    variant="contained" 
                                    color="success" 
                                    onClick={() => {
                                        const phoneNumber = currPreview.Phone; // Use the phone number from currPreview
                                        const message = ''; // Replace with your message or leave it empty
                                        const encodedMessage = encodeURIComponent(message);
                                        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
                                        window.open(whatsappUrl, '_blank');
                                    }}
                                >
                                    <WhatsAppIcon />
                                </Button>
                            </Grid>
                        ) : (
                            <Grid xs={12} sx={{ mb: 5, display: 'flex', justifyContent: 'center' }}>
                                <Button 
                                    variant="contained" 
                                    disabled sx={{mr:5}}
                                >
                                    Cek Chat #1
                                </Button>
                                <Button 
                                    variant="contained" 
                                    color="success" 
                                    onClick={() => {
                                        const phoneNumber = currPreview.Phone; // Use the phone number from currPreview
                                        const message = ''; // Replace with your message or leave it empty
                                        const encodedMessage = encodeURIComponent(message);
                                        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
                                        window.open(whatsappUrl, '_blank');
                                    }}
                                >
                                    <WhatsAppIcon />
                                </Button>
                                
                            </Grid>
                        )}
                    <Grid xs={12} sx={{mb:5}}>
                    <Typography fontSize="20px">Notes: {currPreview.Notes?? "n/a"}</Typography>
                    </Grid>
                    <Grid xs={12} sx={{ mb: 5, display: 'flex', justifyContent: 'center' }}>
                                <Button 
                                    variant="contained" 
                                    color="error" sx={{mr:3}}
                                    onClick={() => {
                                        invalidPost(currPreview._id);
                                        handleClosePreview();
                                    }}
                                >
                                    Nomor Tidak Valid
                                </Button>
                                <Button 
                                    variant="contained" 
                                    sx={{mr:3}}
                                    onClick={() => {
                                        spamPost(currPreview._id);
                                        handleClosePreview();
                                    }}
                                >
                                    Spam
                                </Button>
                                <Button 
                                    variant="contained" 
                                    color="success" 
                                    onClick={() => {
                                        donePost(currPreview._id);
                                        handleClosePreview();
                                    }}
                                >
                                    Sudah
                                </Button>
                            </Grid>
                    </DialogContent>
                    <DialogActions>
                    </DialogActions>
        </Dialog>


    <Grid xs={12}>
    <Paper sx={{height: '100%', width:'100%'}}>
        <TableContainer sx={{ maxHeight: 300, minHeight: 300 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                    <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            
                        </TableCell>
                        <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            Data
                        </TableCell>
                        <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            Akta
                        </TableCell>
                        <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            NPWP
                        </TableCell>
                        <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            NIB
                        </TableCell>
                        <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            PKP
                        </TableCell>
                        <TableCell sx={{...commonStyles, borderColor: 'grey.100' }}>
                            Izin
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {posts && posts.length > 0 ? (
                        posts.map((post) => (
                            <TableRow hover key={post.id}> {/* Ensure to use a unique key for each row */}
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                {post.Nama 
                                    ? post.Nama.slice(0, 7)
                                    : 'N/A'}
                                </TableCell>
                                <MyTableCell post={post} previewInquiry={previewInquiry} cellType="Nama" />
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                    {Array.isArray(post.ProdukInterest) 
                                    ? post.ProdukInterest.join(', ').slice(0, 7)
                                    : (post.ProdukInterest ? String(post.ProdukInterest).slice(0, 7) : 'N/A')}
                                </TableCell>
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                    {Array.isArray(post.LokasiInterest) 
                                    ? post.LokasiInterest.join(', ').slice(0, 7)
                                    : (post.LokasiInterest ? String(post.LokasiInterest).slice(0, 7) : 'N/A')}
                                </TableCell>
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                    {Array.isArray(post.LokasiInterest) 
                                    ? post.LokasiInterest.join(', ').slice(0, 7)
                                    : (post.LokasiInterest ? String(post.LokasiInterest).slice(0, 7) : 'N/A')}
                                </TableCell>
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                    {Array.isArray(post.LokasiInterest) 
                                    ? post.LokasiInterest.join(', ').slice(0, 7)
                                    : (post.LokasiInterest ? String(post.LokasiInterest).slice(0, 7) : 'N/A')}
                                </TableCell>
                                <TableCell sx={{...commonStyles, borderColor: 'grey.100' }} onClick={()=> previewInquiry(post)}  style={{cursor:'pointer'}}>
                                    {Array.isArray(post.LokasiInterest) 
                                    ? post.LokasiInterest.join(', ').slice(0, 7)
                                    : (post.LokasiInterest ? String(post.LokasiInterest).slice(0, 7) : 'N/A')}
                                </TableCell>
                                {/* Other TableCell components */}
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                Done
                            </TableCell>
                        </TableRow>
                    )}
                    {isEnd && (
                        <TableRow>
                            <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>

            </Table>
        </TableContainer>
        </Paper>
        </Grid>


    </Grid>
)
}